import { Query, User } from "@/app/graphql/codegen";
import { useQuery } from "@apollo/client";
import { FETCH_USER_PROFILE } from "@company/graphql/queries/fetchUserProfile";
import { FETCH_COMPANY } from "@company/graphql/queries/fetchCompany";

export const useCompanyProfile = () => {
    const { data, loading } = useQuery<Pick<Query, "company">>(FETCH_COMPANY);

    return {
        company: data?.company,
        loading,
    };
};
